module.exports = __webpack_public_path__ + "img/default_blured.2074b74f.jpg";